import { Action } from "redux";

export type PartiallyBuiltElementsShownEvent = Action<typeof PARTIALLY_BUILT_ELEMENTS_SHOWN>

export const PARTIALLY_BUILT_ELEMENTS_SHOWN = "partially_built_elements_shown";

export const partiallyBuiltElementsShown = (): PartiallyBuiltElementsShownEvent => ({
  type: PARTIALLY_BUILT_ELEMENTS_SHOWN
});
